import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import './AppPage.css';
import './dashboard_grid.css';

import { openDialog } from 'actions/bookingsActions';

import TenantAmenityBookingDialog from './components/tenant_dashboard/todos/TenantAmenityBookingDialog';
import AmenityBookingWaiver from './components/tenant_dashboard/AmenityBookingWaiver';
import AmenityBookings from './components/tenant_dashboard/AmenityBookingComponent';
import AmenityInfo from './components/tenant_dashboard/AmenityInfo';

import { getTranslatedString, getCurrentLocale } from 'helpers/i18n';
import { deepDiver } from 'helpers/utilities';

const DEFAULT_ROW_HEIGHT = 320;

class AmenityBooking extends Component {
  UNSAFE_componentWillMount() {
    this.setState({
      showBooking: false,
      showBookingWaiver: false,
      amenityDetails: {},
    });
  }

  toggleBookingDialog = amenityDetails => {
    if (amenityDetails && amenityDetails.id) {
      this.setState({ showBooking: !this.state.showBooking, amenityDetails });
    } else {
      this.setState({ showBooking: !this.state.showBooking });
    }
  };

  toggleBookingWaiverDialog = amenityDetails => {
    if (amenityDetails && amenityDetails.id) {
      this.setState({ showBookingWaiver: !this.state.showBookingWaiver, amenityDetails });
    } else {
      this.setState({ showBookingWaiver: !this.state.showBookingWaiver });
    }
  };

  render() {
    let defaultHeight = DEFAULT_ROW_HEIGHT;
    const { verbiages } = this.props;

    let disclaimer = getTranslatedString('portalAmenities.amenityDisclaimer');

    if (
      deepDiver(verbiages, `residentPortal.portalAmenities.amenityDisclaimer.${getCurrentLocale()}`)
    ) {
      disclaimer = deepDiver(
        verbiages,
        `residentPortal.portalAmenities.amenityDisclaimer.${getCurrentLocale()}`
      );
    }
    const amenityCards = this.props.amenities.map(amenity => {
      const dialog = this.props.amenityBookingWaiver
        ? this.toggleBookingWaiverDialog
        : this.toggleBookingDialog;
      return (
        <AmenityInfo
          key={amenity.id}
          amenityDetails={amenity}
          defaultHeight={defaultHeight}
          openBookingDialog={dialog}
          landlordLogoUrl={this.props.landlordLogoUrl}
          activeLeaseHasAmenities={this.props.activeLeaseHasAmenities}
        />
      );
    });

    return (
      <Fragment>
        <AmenityBookingWaiver
          onSubmitCallback={() => {
            this.toggleBookingDialog();
            this.toggleBookingWaiverDialog();
          }}
          onCloseCallback={this.toggleBookingWaiverDialog}
          showBookingWaiver={this.state.showBookingWaiver}
          waiver={this.props.amenityBookingWaiver}
        />
        <TenantAmenityBookingDialog
          amenityDetails={this.state.amenityDetails}
          toggleBookingDialog={this.toggleBookingDialog}
          showBooking={this.state.showBooking}
        />
        <div className="centers">
          <div style={{ padding: '0' }}>
            {!this.props.activeLeaseHasAmenities && (
              <p style={{ textAlign: 'justify' }}>
                <i className="em em-warning" />
                Amenities will not be bookable until after your move in date.
                <i className="em em-warning" />
              </p>
            )}

            <p style={{ textAlign: 'justify' }}>{disclaimer}</p>
            <div style={{ marginBottom: '15px' }}>
              <AmenityBookings />
              {this._renderAmenityCards(amenityCards)}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

  _renderAmenityCards = amenityCards => {
    if (this.props.amenities === 0) return;

    return (
      <Fragment>
        <h3 tabIndex="1">{getTranslatedString('portalAmenities.AllAmenities')}</h3>
        {amenityCards}
      </Fragment>
    );
  };
}

const mapStateToProps = function(state) {
  return {
    amenities: state.tenantProfile.amenities,
    landlordLogoUrl: state.userTypes.landlordLogoUrl,
    activeLeaseHasAmenities: state.userTypes.activeLeaseHasAmenities,
    verbiages: state.userTypes.verbiages,
    amenityBookingWaiver: state.tenantProfile.amenityBookingWaiver,
  };
};

export default connect(mapStateToProps, { openDialog })(AmenityBooking);
